import { useCallback } from 'react';
import { hideAccount, refreshApp } from 'actions';
import { setTransactionFilters } from 'actions/deviceSettings';
import useRefreshAccounts from 'hooks/useRefreshAccounts';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import Modal from 'utils/packages/Modal';
import { HIDE_SUCCESS } from 'actions/types';
export const useHideAccount = () => {
    const dispatch = useAppDispatch();
    const refreshAccounts = useRefreshAccounts();
    const transactionFilters = useAppSelector((state) => state.deviceSettings.transactionFilters);
    const hide = useCallback(async (account, onSuccess) => {
        const willBeHidden = !account.isHidden;
        const body = [{ id: account.id, isHidden: willBeHidden }];
        const res = await dispatch(hideAccount(body));
        if (res?.type !== HIDE_SUCCESS)
            return;
        if (willBeHidden && transactionFilters?.selectedAccountsObj) {
            const newSelectedAccounts = {
                ...transactionFilters.selectedAccountsObj,
            };
            delete newSelectedAccounts[account.id];
            dispatch(setTransactionFilters({
                ...transactionFilters,
                selectedAccountsObj: newSelectedAccounts,
            }));
        }
        onSuccess?.();
        refreshAccounts(account.type);
        dispatch(refreshApp());
    }, [dispatch, refreshAccounts, transactionFilters]);
    const handleToggleHidden = useCallback((account, onSuccess) => {
        if (account.isHidden) {
            Modal.showConfirmation({
                title: 'Unhide this account?',
                subtitle: account.isClosed
                    ? 'Its historical balance and transactions will be visible across the app again. To resume syncing, you’ll also need to mark it as open'
                    : 'This account will show up in your main accounts list again and its balance and transactions will now be visible across the app',
                confirmButtonTitle: 'Keep hidden',
                cancelButtonTitle: 'Yes, unhide',
                onPressCancel: () => hide(account, onSuccess),
            });
            return;
        }
        Modal.showConfirmation({
            title: 'Are you sure?',
            subtitle: 'This account will be moved to the Hidden section and the data won’t be visible across the app. If you want it back, just unhide it from the account settings.',
            confirmButtonTitle: 'Yes, let me hide',
            cancelButtonTitle: 'No, thanks',
            onConfirm: () => hide(account, onSuccess),
        });
    }, [hide]);
    return handleToggleHidden;
};
